import { render, staticRenderFns } from "./DialogEditOffice.vue?vue&type=template&id=046d0677"
import script from "./DialogEditOffice.vue?vue&type=script&lang=ts"
export * from "./DialogEditOffice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports